import { MultiSelectFilterVariant } from './types';
import { Option } from './types';

export const getDisplayableInputValue = ({
  variant,
  placeholder,
  value,
  selectedLabels,
}: {
  variant: MultiSelectFilterVariant;
  placeholder: string;
  value: string[];
  selectedLabels: string[];
}) => {
  const valueLength = value.length;

  if (valueLength === 0) {
    return placeholder;
  }

  if (variant === 'secondary') {
    return selectedLabels.join(', ');
  }

  const firstSelectedItemLabel = selectedLabels[0];

  if (valueLength === 1) {
    return firstSelectedItemLabel;
  }

  return `${firstSelectedItemLabel} +${valueLength - 1}`;
};

export const flattenOptions = (options: Option[]): Option[] => {
  return options.flatMap(option =>
    option.options ? flattenOptions(option.options) : option,
  );
};

export const isValueEqualToDefaultValue = (
  value: string[],
  defaultValue?: string[],
) => {
  if (!defaultValue || value.length !== defaultValue.length) {
    return false;
  }

  const sortedValue = [...value].sort();
  const sortedDefaultValue = [...defaultValue].sort();

  return sortedValue.every((v, index) => v === sortedDefaultValue[index]);
};

export const MULTI_SELECT_ITEM_HEIGHT = 28;

export const labelHasSearchTerm = (option: Option, search: string) =>
  option.label.toLowerCase().includes(search.toLowerCase().trim());
